import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { liveQuery } from 'dexie';
import { AreaList, db, TowerRatesList } from 'src/db';
import { DataService } from '../data.service';
import { InputService } from '../input.service';
import * as _ from 'lodash';
import { ApiService } from '../api.service';
import { MatDialog } from '@angular/material/dialog';
import { VarianceSpreadComponent } from '../variance-spread/variance-spread.component';
import { DataUpdateService } from '../data-update.service';
import { LoaderService } from '../loader.service';
import { EncyptDecryptService } from '../encypt-decrypt.service';
import { Subscription } from 'rxjs';
import { config } from 'src/environments/config';
import Swal from 'sweetalert2';
import { TowerParamsComponent } from '../tower-params/tower-params.component';
import { BlendedBenchmarkDetailComponent } from '../blended-benchmark-detail/blended-benchmark-detail.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
@Component({
  selector: 'app-general-price-bar',
  host: { 'class': 'app-general-price-bar' },
  templateUrl: './general-price-bar.component.html',
  styleUrls: ['./general-price-bar.component.scss']
})
export class GeneralPriceBarComponent implements OnInit, OnDestroy {
  @Input() type: string;
  @Input() pdfExport?: boolean = false;
  rows = [];
  locations = [];
  isglobalEdit = false;
  loadedComponentType = 'role';
  selectedExperiences = [];
  experienceFilter = [];
  allRoleRows = [];
  routeParamType = '';
  searchText = '';
  selectedServiceProviders = [];
  skillFactor: any;
  spts: any[];
  minMaxRoles: any = undefined;
  locationsMaster: any[] = [];
  selectedLocation: any;
  locationSingle: any;
  typeNameSelector: string = 'Roles';
  typeNameSelectorTableHeader: string = 'Roles';
  liveQuerySubscription = new Subscription();
  showSelectedOnly: boolean = false;
  subscription = new Subscription();
  noRows = false;
  allRolesSelected: boolean = false;
  isShowOnlySelected: boolean = false;
  displayBoxPlot: boolean = false;
  tooltipText: any;
  allSelected = false;
  hideRemoveTransform: boolean = false;
  loadedBenchmarkType: string = '';
  hideInputLabel: boolean = false;
  hideInfoIcon: boolean;

  @ViewChild('select') select: MatSelect;

  constructor(public dialog: MatDialog,
    private inputService: InputService, private dataService: DataService,
    private loaderService: LoaderService,
    private route: ActivatedRoute, private apiService: ApiService,
    private dataUpdate: DataUpdateService,
    private decryptService: EncyptDecryptService) { }

  ngOnInit(): void {
    this.loaderService.openDialog();
    this.route.params.subscribe(param => {
      switch (param['type']) {
        case 'ru':
          this.loadedBenchmarkType = 'ru';
          this.typeNameSelector = 'RU Benchmark Rates';
          this.hideRemoveTransform = true;
          this.typeNameSelectorTableHeader = 'Resource Unit';
          this.tooltipText = 'Benchmarks for Resource Unit based pricing services across locations';
          this.hideInputLabel = true;
          this.hideInfoIcon = true;
          break;
        case 'blended-rate':
          this.loadedBenchmarkType = 'blended-rate';
          this.typeNameSelector = 'Blended FTE Benchmark Rates using Benchmark SOC';
          this.typeNameSelectorTableHeader = 'Towers';
          this.tooltipText = ['Blended FTE Benchmark Rates based on the benchmark span of control for each tower.', ' Blended FTE Rate = Average Role Based Benchmark FTE Rate per Level * Benchmark SOC '];
          break;
        case 'role-level':
          this.loadedBenchmarkType = 'fte';
          this.typeNameSelector = 'FTE Benchmark Rates';
          this.typeNameSelectorTableHeader = 'Roles';
          this.hideInfoIcon = true;
          break;
        default:
          this.typeNameSelector = 'FTE Benchmark Rates';
          this.tooltipText = 'Benchmarks for FTE based pricing services across locations';
      }

    })
    this.subscription = this.dataUpdate.subscribeDataChangeEvent().subscribe(event => {
      if (['locationSelectionsChanged', 'towerSubtowerUpdate', 'providerChanged', 'categoryChanged', 'areaUpdated', 'skillValueChanged', 'towerParamsUpdated', 'dealParamUpdated'].indexOf(event) != -1) {
        this.loaderService.openDialog();
        setTimeout(() => {
          this.getData();
          //this.loaderService.closeDialog();
        }, 1000)
      }
      if (['discreteSelected'].indexOf(event) != -1) {
        this.isglobalEdit = true;
      }
    })
    this.showSelectedOnly = localStorage.getItem('showOnlySelected') == 'true'
    this.isShowOnlySelected = localStorage.getItem('showOnlySelected') == 'true'
    this.getData();
    setTimeout(() => { this.displayBoxPlot = true }, 2000);

  }

  ngOnDestroy(): void {
    this.liveQuerySubscription.unsubscribe();
    this.subscription.unsubscribe();
  }

  getData() {
    this.getSelectedLocations().then(async (data) => {
      this.locationsMaster = data;
      this.locations = data;
      this.selectedLocation = data[0]['id'];
      await this.getRowDatas();
    });
  }

  async getDealParamOptions() {
    return await db.selection_deal_tower_params_values.toArray();
  }

  async getSelectedLocations() {
    this.skillFactor = await this.dataService.getSkillFactor();
    this.selectedServiceProviders = (await db.selection_providerTypes.toArray()).filter(x => x.isSelected == true);
    let area: AreaList[] = await this.dataService.getDataFromDb('areas', {}, true);
    if (area.length > 0) {
      return (await this.dataService.getDataFromDb('locations', {}, true)).filter(e => area[0].locationMappings.includes(e.id));
    }
    return Promise.resolve([])
  }

  cliPrice = [];

  async refreshBoxPlot(isBoxPlot) {
    if (isBoxPlot)
      await this.getRowDatas();
  }

  updateBoxPlot() {
    this.locationSingle = [];
    this.locationSingle = _.filter(this.locations, (loc) => {
      return loc.id == this.selectedLocation
    });

  }

  async getRowDatas() {
    switch (this.type) {
      case 'role-level':
        this.loadedComponentType = 'role';
        this.getRoles().then(async (data) => {
          this.minMaxRoles = await this._getMinMaxRangeForLocationProvider(data);
          let locs = Array.from(new Set(data.flatMap(e => e["rates"]).map(e => e.location)));
          //this.locations = this.locationsMaster.filter(loc => locs.includes(loc.id));

          
          this.transformData(data)
          this.updateBoxPlot();
          let experiences = _.uniqBy(data, 'roleData.experience').map(role => { if (role.roleData) return role.roleData.experience });
          experiences = _.compact(experiences);
          experiences = this._sortExperience(experiences)
          this.experienceFilter = experiences;
          this.allRoleRows = data;
          this.allRolesSelected = this.allRoleRows.filter(role => { return role.isSelected }).length == this.allRoleRows.length;
          if (data.length == 0)
            this.noRows = true;
          else
            this.noRows = false;
          this.loaderService.closeDialog();
          this.allSelected = true;
          this.selectedExperiences = experiences;
          if (this.showSelectedOnly) {
            this.filterRolesByExperienceAndSelected()
          }
          else {
            //this.toggleAllSelection();
          }
        })
        break;
      case 'blended-rate':
        this.loadedComponentType = 'tower';
        this.getTowers().then(async (data) => {
          this.minMaxRoles = await this._getMinMaxRangeForLocationProvider(data, 'towers')
          let locs = Array.from(new Set(data.flatMap(e => e["rates"]).map(e => e.location)));
          //this.locations = this.locationsMaster.filter(loc => locs.includes(loc.id));

          this.transformData(data)
          this.updateBoxPlot();
          if (data.length == 0)
            this.noRows = true;
          else
            this.noRows = false;
          this.loaderService.closeDialog();
        });
        break;
    }
  }

  async markAllRolesAsSelected(e: Event) {
    this.allRolesSelected = e.target['value'] == 'true';
    if (this.allRolesSelected) {
      let allRoles = this.allRoleRows.filter(role => { return role.isSelected });
      allRoles.forEach(role => {
        role.isSelected = false;
      })
      await db.selection_roles.clear();
      this.allRolesSelected = false;
    }
    else {
      let allRoles = this.allRoleRows.filter(role => { return !role.isSelected });
      allRoles.forEach(role => {
        role.isSelected = true;
      })
      await db.selection_roles.bulkAdd(allRoles);
      this.allRolesSelected = true;
    }
    this.dataUpdate.emitDataChangeEvent('allRolesSelectionChanged')
  }

  _sortExperience(experiences) {
    return experiences.sort((a, b) => {
      a = Math.min(...a.split('-').map(x => { return parseInt(x) }))
      b = Math.min(...b.split('-').map(x => { return parseInt(x) }))
      return a - b;
    })
  }


  transformData(data) {
    data.forEach(d => {
      try {
        d['label'] = (this.loadedComponentType == 'role') ? d.role : d.tower;
        if (this.loadedComponentType == 'role' && this.loadedBenchmarkType != 'ru') {
          if (d['roleData'])
            d['roleData']['level'] = d['roleData']['level'].replace('Level ', 'L')
        }
      } catch (e) { }
    })
    if (this.showSelectedOnly) {
      this.rows = data.filter((role: any) => {
        return role.isSelected;
      })
    }
    else
      this.rows = data;
  }

  async getTowers() {
    return await this.dataService.getTowerWithRatesInputPlot();
  }

  async getRoles() {
    return await this.dataService.getRolesWithRatesInputPlot()
  }

  getValue(obj, spid) {
    if (obj != undefined && obj[spid] != undefined) {
      return config.formatNumber(obj[spid]);
    }
    else return '';
  }

  async getLocationsFromDb() {
    this.skillFactor = await this.dataService.getSkillFactor();
    return await this.dataService.getDataFromDb('locations', {}, true);
  }

  async updateBoxPlotValue(id, location, spId, event) {
    if (event.target.value < 0) {
      //alert('Please enter Positive Values!!')
      Swal.fire({
        //title: 'Warning!',
        text: 'Please enter positive values only',
        icon: 'info',
        confirmButtonText: 'Close'
      });
      event.target.value = null;
      return false;
    }
    let data = {
      location: location,
      inputValue: isNaN(event.target.value) ? 0 : Math.round(event.target.value * 100) / 100,
      serviceProvider: spId
    }
    data[this.loadedComponentType] = id;
    await this.inputService.updateInputPlotValue(data)
    return true;
  }

  async onRowSelected(checked, roleData) {
    roleData.id = roleData.id;
    roleData.isSelected = checked;
    if (checked == false && this.isShowOnlySelected) {
      this.rows = this.allRoleRows.filter((role: any) => {
        return role.isSelected;
      })
    }
    await this.dataService.updateRecord('roles', roleData);
  }

  async clearData() {
    await db.input_plot.clear();
    this.getRowDatas();
  }

  toggleAllSelection() {
    if (this.allSelected) {
      this.select.options.forEach((item: MatOption) => { item.select() });
    } else {
      this.select.options.forEach((item: MatOption) => item.deselect());
    }
    this.filterRolesByExperience()
  }

  filterRolesByExperience(e = null) {
    this.selectedExperiences = e;
    this.allSelected = this.experienceFilter.length === this.selectedExperiences.length;
    this.filterRolesByExperienceAndSelected();
  }

  showOnlySelected(event) {
    localStorage.setItem('showOnlySelected', event.checked);
    this.isShowOnlySelected = event.checked;
    this.filterRolesByExperienceAndSelected(true);
  }

  filterRolesByExperienceAndSelected(emitExperience = false) {
    if (this.loadedBenchmarkType == 'ru')
      emitExperience = true;
    this.rows = this.allRoleRows.filter((role: any) => {
      if (this.isShowOnlySelected) {
        if (emitExperience) {
          return role['isSelected'];
        }
        return this.selectedExperiences.indexOf(role.roleData['experience']) > -1 && role['isSelected'];
      }
      if (emitExperience)
        return true;
      return this.selectedExperiences.length == 0 || this.selectedExperiences.indexOf(role.roleData['experience']) > -1;
    });
  }

  private async _getMinMaxRangeForLocationProvider(data, mode = 'roles') {
    let minMaxRoles = {};
    let rates = {};
    _.forEach(data, (item) => {
      _.forEach(item.rateSPT, (rate, location) => {
        if (!rates[location])
          rates[location] = {}
        _.forEach(rate, (values, spid) => {
          if (!rates[location][spid])
            rates[location][spid] = {}
          _.forEach(values, (rate, bp) => {
            if (!rates[location][spid][bp])
              rates[location][spid][bp] = []
            rates[location][spid][bp].push(rate)
          })
        })
      })
    })
    _.forEach(rates, (rate, location) => {
      minMaxRoles[location] = {}
      _.forEach(rate, (values, sp) => {
        minMaxRoles[location][sp] = {
          min: _.min(values[25]) - 5,
          max: _.max(values[75]) + 5,
          buckets: (() => {
            let arr = [],
              min = _.min(values[25]) - 5,
              max = _.max(values[75]) + 5,
              i,
              buckets = 3;
            for (i = min; i <= max; i += (max - min) / buckets) {
              arr.push(i);
            }
            return arr;
          })()
        }
      })
    })
    //this.minMaxRoles = minMaxRoles;
    return Promise.resolve(minMaxRoles)
  }

  formatNumber(value) {
    if (value.toString().indexOf('.') > -1)
      return value.toFixed(0);
    else
      return value;
  }

  openVarianceDialog() {
    let type = this.type == 'blended-rate' ? 'tower' : 'role';
    const dialogRef = this.dialog.open(VarianceSpreadComponent, {
      width: '70%',
      panelClass: 'variance-spread-modal',
      data: {
        type: type
      }
    });
  }

  async openTowerParamsDialog() {
    this.dataService.getTowerParams().then(result => {
      if (Object.keys(result['grouped']).length > 0) {
        const dialogRef = this.dialog.open(TowerParamsComponent, {
          width: '1228.8px',
          maxWidth: 'inherit',
          panelClass: 'variance-spread-modal',
        });
      }
      else {
        Swal.fire({
          //title: 'Warning!',
          text: 'Please select atleast one Service from the list',
          icon: 'info',
          confirmButtonText: 'Close'
        });
      }
    })

  }

  html = `<ul>
  <li>Identifies and documents the current technical environment</li> 	<li>Participates in and documents interviews as a part of requirements gathering, high level scope definition, development of use cases</li>
  <li>Creates test scripts for functional verification and user acceptance testing</li>
  </ul>`;


  // getWidthAsPerSelections(){
  //   return this.selectedServiceProviders.length == 1 ? 400:250
  // }

  getWidthAsPerSelections() {
    let element = document.getElementsByClassName("sub-header-td")[0] as HTMLElement;
    return element.offsetWidth - 33;
  }

  openBenchmarkDetail(row) {
    const dialogRef = this.dialog.open(BlendedBenchmarkDetailComponent, {
      width: '70%',
      panelClass: 'variance-spread-modal',
      data: {
        row,
        location: this.selectedLocation
      }
    });
  }

  getTooltipText(row) {
    return row.selectedSubtowers.map(st => { return st.subTower }).join(' | ')
  }

  someComplete(): boolean {
    if (this.selectedExperiences.length == 0)
      return false;
    return true;

    return this.allSelected = this.experienceFilter.length === this.selectedExperiences.length;
  }

  getHeadingTooltipText() {
    if (typeof this.tooltipText == 'object')
      return ` ${this.tooltipText[0]}
      ${this.tooltipText[1]}`
    return this.tooltipText;
  }



}
